import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button';
import { AuditLogItem } from '../../../../interfaces/auditLog.interface';

interface DetailModalTitleProps {
  item: AuditLogItem | null;
  onClose: () => void;
}

/** Title block: title, an "Entity › Record" trail with the record in bold, and a close icon. */
const DetailModalTitle: React.FC<DetailModalTitleProps> = ({ item, onClose }) => {
  const { t } = useTranslation();

  const hasValue = (part?: string) => !!part && part !== '-';

  return (
    <div className="d-flex justify-content-between align-items-start w-100">
      <div>
        <h5 className="fw-bold mb-0">{t('auditLogs.list.pageTexts.detail.title')}</h5>
        {item && hasValue(item.entity) && (
          <div className="text-body small" data-testid="audit-log-breadcrumb">
            {item.entity}
            {hasValue(item.subject) && (
              <>
                <span className="mx-1" aria-hidden="true">›</span>
                <span className="fw-semibold">{item.subject}</span>
              </>
            )}
          </div>
        )}
      </div>
      <Button
        className="btn btn-sm btn-icon btn-text-secondary"
        icon={<i className="ri-close-line ri-20px" aria-hidden="true" />}
        aria-label={t('auditLogs.list.pageTexts.detail.close')}
        onClick={onClose}
      />
    </div>
  );
};

export default DetailModalTitle;
